<div class="h6">Articles</div>
<div *ngFor="let contentElement of cell?.contentElements" [ngClass]="contentElement.containerClasses">
    <kw-content-element-renderer [contentElement]="contentElement" [preview]="preview" (updatedContent)="onUpdateContent($event)"></kw-content-element-renderer>
</div>
